var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialValue)?_c('color-picker',{attrs:{"show-opacity":!this.unFormatted,"value":_vm.initialValue},on:{"change":_vm.setColor}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }